module.exports = __webpack_public_path__ + "media/סבתא.f783255b.mp3";